/* eslint-disable react/prop-types */
import React from 'react'
import { FallbackProps } from 'react-error-boundary'
import { useIntl } from 'react-intl'

import { Alert, Typography } from 'antd'

import useLogger from 'hooks/useSentryLogger'

import { handleError } from 'utils/errorHandler'

const ErrorFallback: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const intl = useIntl()
  const logger = useLogger()
  const errorMessage = handleError(error, intl, {
    showNotification: false,
    fallbackMessage: 'global.error.messages.fallbackError',
  })
  logger.error('component', String(error))

  return (
    <Alert
      type="error"
      showIcon
      message={
        <>
          {errorMessage}{' '}
          <Typography.Link onClick={resetErrorBoundary}>
            {intl.formatMessage({ id: 'global.error.messages.tryAgain' })}
          </Typography.Link>
        </>
      }
    />
  )
}

export default ErrorFallback
